import { defineMessages, FormattedMessage } from 'react-intl';
import React from 'react';

const messages = defineMessages({
  advancedSearch: {
    description: 'ordersPage.nav.advancedSearch',
    defaultMessage: 'Advanced Search',
    id: 'bw18Xd',
  },
  allSearchResults: {
    defaultMessage: 'All Search Results',
    description: 'ordersPage.nav.allOrdersSearchResult',
    id: '8jirJk',
  },
  awaitingPayment: {
    defaultMessage: 'Awaiting Payment',
    description: 'ordersPage.nav.awaitingPayment',
    id: 'OY4FE0',
  },
  awaitingShipment: {
    defaultMessage: 'Awaiting Shipment',
    description: 'ordersPage.nav.awaitingShipment',
    id: 'xtwwVH',
  },
  cancelled: {
    defaultMessage: 'Cancelled',
    description: 'ordersPage.nav.cancelled',
    id: 'xA9/Jj',
  },
  onHold: {
    defaultMessage: 'On Hold',
    description: 'ordersPage.nav.onHold',
    id: '284yK2',
  },
  combineShipments: {
    defaultMessage: 'Combine Shipments',
    description: 'ordersPage.nav.orderAlertscombineShipments',
    id: '3wJM2h',
  },
  orderAlerts: {
    defaultMessage: 'Order Alerts',
    description: 'ordersPage.nav.orderAlerts',
    id: 'MaE/Vi',
  },
  openBatches: {
    defaultMessage: 'Open Batches',
    description: 'routes.openBatches',
    id: 'Qubpi/',
  },
  pendingFulfillment: {
    defaultMessage: 'Pending Fulfillment',
    description: 'ordersPage.nav.pendingFulfillment',
    id: 'e+IhHv',
  },
  rejectedFulfillment: {
    defaultMessage: 'Rejected Fulfillment',
    description: 'ordersPage.nav.rejectedFulfillment',
    id: 'TkiYmY',
  },
  pendingPickup: {
    description: 'ordersPage.nav.pendingPickup',
    defaultMessage: 'Pending Pickup',
    id: '+O/4PI',
  },
  shipped: {
    defaultMessage: 'Shipped',
    description: 'ordersPage.nav.shipped',
    id: 'qeM+7N',
  },
});

export const ADVANCED_SEARCH_ID = 'advanced-search';
export const ADVANCED_SEARCH_VIEW = {
  label: <FormattedMessage {...messages.advancedSearch} />,
  id: ADVANCED_SEARCH_ID,
  hideSearchPrefix: true,
};

export const ALL_ORDERS_SEARCH_RESULT_ID = 'all-orders-search-result';
export const ALL_ORDERS_SEARCH_RESULT_VIEW = {
  label: <FormattedMessage {...messages.allSearchResults} />,
  id: ALL_ORDERS_SEARCH_RESULT_ID,
  hideSearchPrefix: true,
};

export const AWAITING_PAYMENT_ID = 'awaiting-payment';
export const AWAITING_PAYMENT_VIEW = {
  label: <FormattedMessage {...messages.awaitingPayment} />,
  id: AWAITING_PAYMENT_ID,
  count: 0,
};

export const AWAITING_SHIPMENT_ID = 'awaiting-shipment';
export const AWAITING_SHIPMENT_VIEW = {
  label: <FormattedMessage {...messages.awaitingShipment} />,
  id: AWAITING_SHIPMENT_ID,
  // why is this 5?
  count: 5,
};

export const CANCELLED_ID = 'cancelled';
export const CANCELLED_VIEW = {
  label: <FormattedMessage {...messages.cancelled} />,
  id: CANCELLED_ID,
};

export const ON_HOLD_ID = 'on-hold';
export const ON_HOLD_VIEW = {
  label: <FormattedMessage {...messages.onHold} />,
  id: ON_HOLD_ID,
};

export const ORDER_ALERTS_SHIP_TOGETHER_ID = 'shiptogether';
export const ORDER_ALERTS_SHIP_TOGETHER_VIEW = {
  label: <FormattedMessage {...messages.combineShipments} />,
  expandedDescription: <FormattedMessage {...messages.combineShipments} />,
  id: ORDER_ALERTS_SHIP_TOGETHER_ID,
  routePath: 'alerts/shiptogether',
};

export const ORDER_ALERTS_ID = 'alerts';
export const ORDER_ALERTS_VIEW = {
  label: <FormattedMessage {...messages.orderAlerts} />,
  id: ORDER_ALERTS_ID,
  // why is this the same?
  routePath: 'alerts/shiptogether',
};

export const ORDER_BATCHES_ID = 'batches';
export const ORDER_BATCHES_VIEW = {
  label: <FormattedMessage {...messages.openBatches} />,
  id: ORDER_BATCHES_ID,
};

export const PENDING_FULFILLMENT_ID = 'pending-fulfillment';
export const PENDING_FULFILLMENT_VIEW = {
  label: <FormattedMessage {...messages.pendingFulfillment} />,
  id: PENDING_FULFILLMENT_ID,
};

export const REJECTED_FULFILLMENT_ID = 'rejected-fulfillment';
export const REJECTED_FULFILLMENT_VIEW = {
  label: <FormattedMessage {...messages.rejectedFulfillment} />,
  id: REJECTED_FULFILLMENT_ID,
};

export const PENDING_PICKUP_ID = 'pending-pickup';
export const PENDING_PICKUP_VIEW = {
  label: <FormattedMessage {...messages.pendingPickup} />,
  id: PENDING_PICKUP_ID,
};

export const SHIPPED_ID = 'shipped';
export const SHIPPED_VIEW = {
  label: <FormattedMessage {...messages.shipped} />,
  id: SHIPPED_ID,
};

export const BATCHES_ID = 'batches';

export const ALL_ORDERS_PAGE_VIEWS = [
  ADVANCED_SEARCH_VIEW,
  ALL_ORDERS_SEARCH_RESULT_VIEW,
  AWAITING_PAYMENT_VIEW,
  AWAITING_SHIPMENT_VIEW,
  CANCELLED_VIEW,
  ON_HOLD_VIEW,
  ORDER_ALERTS_SHIP_TOGETHER_VIEW,
  ORDER_ALERTS_VIEW,
  ORDER_BATCHES_VIEW,
  PENDING_FULFILLMENT_VIEW,
  REJECTED_FULFILLMENT_VIEW,
  PENDING_PICKUP_VIEW,
  SHIPPED_VIEW,
];
